import { FormControl, FormHelperText, OutlinedInput, Stack, Typography, useMediaQuery } from '@mui/material'
import React, { FunctionComponent, SetStateAction } from 'react'
import gaiaTheme from '../../../../root-components/theme'
import FormEditButtons from './form-edit-buttons'

export const FormTextDoubleInput: FunctionComponent<{
  isEditPage: boolean,
  editField?: string | undefined,
  setEditField?: React.Dispatch<SetStateAction<any>> | undefined,
  hideEditIcon?: boolean,
  disabled: boolean,
  title: string,
  firstName: string,
  secondName: string,
  type?: 'text' | 'email' | 'number'
  firstValue: string | number | undefined,
  secondValue: string | number | undefined,
  firstTouched?: any,
  secondTouched?: any,
  firstErrors?: any,
  secondErrors?: any,
  onChange: any,
  cancelEditHandler?: () => void,
  onCancelWithName?: (name: string) => void,
  firstPlaceholder?: string,
  secondPlaceholder?: string,
  isTopRow?: boolean,
  isBottomRow?: boolean,
}> = ({
  isEditPage,
  editField,
  setEditField,
  hideEditIcon = false,
  disabled,
  title,
  firstName,
  secondName,
  type = 'text',
  firstValue,
  secondValue,
  firstTouched,
  secondTouched,
  firstErrors,
  secondErrors,
  onChange,
  cancelEditHandler,
  onCancelWithName,
  firstPlaceholder,
  secondPlaceholder,
  isTopRow = false,
  isBottomRow = false,
}) => {

    const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

    const toggleEditField = (fieldName: string) => {
      if (setEditField) {
        setEditField(fieldName)
      }
    }

    return (
      <FormControl fullWidth variant='outlined'>
        <Stack sx={{
          borderWidth: '1px',
          borderColor: 'lightGrey.main',
          borderLeftStyle: 'solid',
          borderRightStyle: 'solid',
          borderTopStyle: 'solid',
          borderBottomStyle: isBottomRow ? 'solid' : 'none',
          pt: 1, pb: isMobileMode ? 5 : 1, pl: 2, pr: 2,
          borderTopLeftRadius: isTopRow ? '10px' : 0,
          borderTopRightRadius: isTopRow ? '10px' : 0,
          borderBottomLeftRadius: isBottomRow ? '10px' : 0,
          borderBottomRightRadius: isBottomRow ? '10px' : 0
        }}>
          <Stack position='relative' alignItems={isMobileMode ? 'stretch' : 'center'} flexDirection={isMobileMode ? 'column' : 'row'} justifyContent='start' spacing={2} sx={{ pb: 1 }}>
            <Stack sx={{ width: isMobileMode ? '100%' : '20%', minWidth: '140px', color: 'text.primary', display: 'flex', flexDirection: 'row', alignItems: 'center', minHeight: '40px' }}>
              <Typography variant='subtitle1' sx={{ mt: 2 }}> {title} </Typography>
            </Stack>
            <Stack position='relative' flexDirection={isMobileMode ? 'column' : 'row'} sx={{ width: '100%', alignItems: 'center', justifyContent: 'space-between', gap: 1, pr: isMobileMode ? 0 : 12 }}>
              <OutlinedInput id={firstName} size='small' name={firstName} type={type}
                value={firstValue}
                disabled={disabled || editField !== firstName}
                onChange={onChange}
                fullWidth
                placeholder={firstPlaceholder}
                inputProps={{ min: 0, step: 1 }}
                error={firstTouched && Boolean(firstErrors)}
                sx={{
                  ...((editField !== firstName && isEditPage) && {
                    '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
                  }),
                  ...((editField === firstName || !isEditPage) && {
                    '& .MuiOutlinedInput-notchedOutline': { borderColor: 'text.secondary' }
                  }),
                  color: 'text.primary'
                }}></OutlinedInput>
              <OutlinedInput id={secondName} size='small' name={secondName} type={type}
                value={secondValue}
                disabled={disabled || editField !== firstName}
                onChange={onChange}
                fullWidth
                placeholder={secondPlaceholder}
                inputProps={{ min: 0, step: 1 }}
                error={secondTouched && Boolean(secondErrors)}
                sx={{
                  ...((editField !== firstName && isEditPage) && {
                    '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
                  }),
                  ...((editField === firstName || !isEditPage) && {
                    '& .MuiOutlinedInput-notchedOutline': { borderColor: 'text.secondary' }
                  }),
                  color: 'text.primary'
                }}></OutlinedInput>
              {!isMobileMode && (
                <FormEditButtons
                  isEditPage={isEditPage}
                  editField={editField}
                  hideEditIcon={hideEditIcon}
                  name={firstName}
                  toggleEditField={toggleEditField}
                  cancelEditHandler={onCancelWithName ? () => onCancelWithName(firstName) : cancelEditHandler}
                />
              )}
            </Stack>
            {isMobileMode && (
              <Stack position='relative' alignItems='flex-end' sx={{ mt: 1 }}>
                <FormEditButtons
                  isEditPage={isEditPage}
                  editField={editField}
                  hideEditIcon={hideEditIcon}
                  name={firstName}
                  toggleEditField={toggleEditField}
                  cancelEditHandler={onCancelWithName ? () => onCancelWithName(firstName) : cancelEditHandler}
                />
              </Stack>
            )}
          </Stack>
          <Stack>
            {(firstTouched && firstErrors) &&
              <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                {firstErrors ? <div>{firstErrors as string}</div> : null}
              </FormHelperText>
            }
            {(secondTouched && secondErrors) &&
              <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                {secondErrors ? <div>{secondErrors as string}</div> : null}
              </FormHelperText>
            }
          </Stack>
        </Stack>
      </FormControl>
    )
  }